// https://flagpedia.net/index
// https://www.codigosinternacionales.com/ladas-de-paises/
// https://en.wikipedia.org/wiki/List_of_mobile_telephone_prefixes_by_country
export default [
  { key: 'us', code: '+1', name: 'USA' },
  { key: 'ca', code: '+1', name: 'Canada' },
  { key: 'mx', code: '+52', name: 'México' },
  { key: 'ar', code: '+54', name: 'Argentina' },
  { key: 'br', code: '+55', name: 'Brasil' },
  { key: 'cl', code: '+56', name: 'Chile' },
  { key: 'co', code: '+57', name: 'Colombia' },
  { key: 'cr', code: '+506', name: 'Costa Rica' },
  { key: 'de', code: '+49', name: 'Deutschland' },
  { key: 'ec', code: '+593', name: 'Ecuador' },
  { key: 'sv', code: '+503', name: 'El Salvador' },
  { key: 'es', code: '+34', name: 'España' },
  { key: 'fr', code: '+33', name: 'France' },
  { key: 'gt', code: '+502', name: 'Guatemala' },
  { key: 'hn', code: '+504', name: 'Honduras' },
  { key: 'nl', code: '+31', name: 'Nederland' },
  { key: 'pa', code: '+507', name: 'Panama' },
  { key: 'pe', code: '+51', name: 'Perú' },
  { key: 'ch', code: '+41', name: 'Switzerland' },
  { key: 'gb', code: '+44', name: 'United Kingdom' },
  { key: 'uy', code: '+598', name: 'Uruguay' }
]
